import React, { useEffect, useState } from 'react';
import { Box, InputAdornment, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton } from '../../../../components/CustomButton';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../constants/routes';
import { CustomInput } from '../../../../components/CustomInput';
import { ReactComponent as SearchIcon } from '../../../../assets/images/search.svg';
import { getEventDeclensionForm } from '../../../../utils/getEventDeclension';
import EnhancedTable from '../../../../components/EnhancedTable';
import { COMPANY_PROMOTIONS_HEAD_CELLS, PROMOTION_STATUSES } from '../../constants/index';
import { CustomModal } from '../../../../components/CustomModal';
import {
  getPromotions,
  getCitiesList,
  updatePromotionStatus,
  clearErrors
} from '../../../../store/companyPromotions';
import { NotFoundItems } from '../../../../components/NotFoundItems';
import { CustomSelect } from '../../../../components/CustomSelect';
import { FirstTextSelect } from '../../../../components/FirstTextSelcet';
import { useDebounce } from 'use-lodash-debounce';
import { ReactComponent as ReportRedIcon } from '../../../../assets/images/report_red.svg';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';
import { CompanyPromotionsTableBody } from '../CompanyPromotionsTableBody';

const propsSelect = (name, text, options, value) => ({
  name,
  options,
  value,
  startAdornmentText: <FirstTextSelect text={text} />,
  size: 'small',
  variant: 'outlined'
});

export const CompanyPromotionsList = () => {
  const dispatch = useDispatch();
  const {
    promotions,
    promotionsLoading,
    promotionsError,
    cities,
    statusUpdateLoading
  } = useSelector((state) => state.companyPromotions);

  const [filter, setFilter] = useState({
    order_by: 'id',
    order_type: 'asc',
    search: '',
    status: PROMOTION_STATUSES[0],
    city: { value: 'all', label: 'Все' },
    partner: { value: 'all', label: 'Все' },
    date_start: null,
    date_end: null,
    page: 0,
    size: 10
  });

  const [isArchiveModal, setIsArchiveModal] = useState(false);
  const [currentPromotion, setCurrentPromotion] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const citiesOptions = cities?.filials?.map(city => ({
    label: city.city_name,
    value: city.id
  })) || [];
  citiesOptions.unshift({ label: 'Все', value: 'all' });

  useEffect(() => {
    dispatch(getCitiesList());
  }, [dispatch]);

  useEffect(() => {
    if (promotionsError) {
      setErrorMessage(promotionsError);
      setErrorModal(true);
    }
  }, [promotionsError]);

  const debouncedValue = useDebounce(filter.search, 500);

  useEffect(() => {
    const params = {
      order_by: filter.order_by,
      order_type: filter.order_type,
      search: debouncedValue !== '' ? debouncedValue : undefined,
      page: filter.page + 1,
      size: filter.size,
      city: filter.city.value !== 'all' ? filter.city.value : undefined,
      status: filter.status.value !== 'all' ? filter.status.value : undefined,
      date_start: filter.date_start ? filter.date_start.toISOString().split('T')[0] : undefined,
      date_end: filter.date_end ? filter.date_end.toISOString().split('T')[0] : undefined
    };

    dispatch(getPromotions(params));
  }, [
    filter.city,
    filter.page,
    filter.status,
    debouncedValue,
    filter.order_type,
    filter.size,
    filter.order_by,
    filter.date_start,
    filter.date_end,
    dispatch
  ]);

  const handlerOnChange = (e, field) => setFilter({ ...filter, page: 0, [field]: e });

  const handleArchivePromotion = (promotion) => {
    setCurrentPromotion(promotion);
    setIsArchiveModal(true);
  };


  const handleApprovePromotion = async (promotion) => {
    setCurrentPromotion(promotion);
    try {
      await dispatch(updatePromotionStatus(promotion.id, 'APPROVED'));
      // Обновляем список акций после успешного обновления статуса
      const params = {
        ...filter,
        search: filter.search !== '' ? filter.search : undefined,
        page: filter.page + 1,
        city: filter.city.value !== 'all' ? filter.city.value : undefined,
        status: filter.status.value !== 'all' ? filter.status.value : undefined,
        date_start: filter.date_start ? filter.date_start.toISOString().split('T')[0] : undefined,
        date_end: filter.date_end ? filter.date_end.toISOString().split('T')[0] : undefined
      };
      dispatch(getPromotions(params));
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error);
    }
  };

  const handleRejectPromotion = async (promotion) => {
    setCurrentPromotion(promotion);
    try {
      await dispatch(updatePromotionStatus(promotion.id, 'REJECTED'));
      // Обновляем список акций после успешного обновления статуса
      const params = {
        ...filter,
        search: filter.search !== '' ? filter.search : undefined,
        page: filter.page + 1,
        city: filter.city.value !== 'all' ? filter.city.value : undefined,
        status: filter.status.value !== 'all' ? filter.status.value : undefined,
        date_start: filter.date_start ? filter.date_start.toISOString().split('T')[0] : undefined,
        date_end: filter.date_end ? filter.date_end.toISOString().split('T')[0] : undefined
      };
      dispatch(getPromotions(params));
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error);
    }
  };

  const handleActivatePromotion = async (promotion) => {
    setCurrentPromotion(promotion);
    try {
      await dispatch(updatePromotionStatus(promotion.id, 'ACTIVE'));
      // Обновляем список акций после успешного обновления статуса
      const params = {
        ...filter,
        search: filter.search !== '' ? filter.search : undefined,
        page: filter.page + 1,
        city: filter.city.value !== 'all' ? filter.city.value : undefined,
        status: filter.status.value !== 'all' ? filter.status.value : undefined,
        date_start: filter.date_start ? filter.date_start.toISOString().split('T')[0] : undefined,
        date_end: filter.date_end ? filter.date_end.toISOString().split('T')[0] : undefined
      };
      dispatch(getPromotions(params));
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error);
    }
  };

  const handleSendForApproval = async (promotion) => {
    setCurrentPromotion(promotion);
    try {
      await dispatch(updatePromotionStatus(promotion.id, 'IN_APPROVAL'));
      // Обновляем список акций после успешного обновления статуса
      const params = {
        ...filter,
        search: filter.search !== '' ? filter.search : undefined,
        page: filter.page + 1,
        city: filter.city.value !== 'all' ? filter.city.value : undefined,
        status: filter.status.value !== 'all' ? filter.status.value : undefined,
        date_start: filter.date_start ? filter.date_start.toISOString().split('T')[0] : undefined,
        date_end: filter.date_end ? filter.date_end.toISOString().split('T')[0] : undefined
      };
      dispatch(getPromotions(params));
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error);
    }
  };

  const confirmArchive = async () => {
    if (currentPromotion) {
      try {
        await dispatch(updatePromotionStatus(currentPromotion.id, 'DEACTIVATED'));
        // Обновляем список акций после успешного обновления статуса
        const params = {
          ...filter,
          search: filter.search !== '' ? filter.search : undefined,
          page: filter.page + 1,
          city: filter.city.value !== 'all' ? filter.city.value : undefined,
          status: filter.status.value !== 'all' ? filter.status.value : undefined,
          date_start: filter.date_start ? filter.date_start.toISOString().split('T')[0] : undefined,
          date_end: filter.date_end ? filter.date_end.toISOString().split('T')[0] : undefined
        };
        dispatch(getPromotions(params));
        setIsArchiveModal(false);
        setCurrentPromotion(null);
      } catch (error) {
        console.error('Ошибка при обновлении статуса:', error);
      }
    }
  };


  const closeErrorModal = () => {
    setErrorModal(false);
    setErrorMessage('');
    dispatch(clearErrors());
  };

  return (
    <Box data-testid="CompanyPromotionsList">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="24px">
        <CustomButton
          component={Link}
          to={ROUTES.COMPANY_PROMOTIONS_CREATE}
          size="small"
          mr="24px"
          variant="contained">
          Создать акцию
        </CustomButton>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center">
          <CustomInput
            value={filter.search}
            onChange={(e) => setFilter({ ...filter, search: e.target.value, page: 0 })}
            size="small"
            variant="outlined"
            type="search"
            placeholder="Поиск"
            sx={{ width: '343px' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Box>
      </Box>

      <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gap="16px" mb="24px" flexWrap="wrap">
        <CustomDatePicker
          placeholder="Дата начала действия:"
          value={filter.date_start}
          onChange={(date) => setFilter({ ...filter, date_start: date, page: 0 })}
          size="small"
          sx={{ width: '100%' }}
        />

        <CustomDatePicker
          placeholder="Дата окончания действия:"
          value={filter.date_end}
          onChange={(date) => setFilter({ ...filter, date_end: date, page: 0 })}
          size="small"
          sx={{ width: '100%' }}
        />

        <CustomSelect
          {...propsSelect('status', 'Статус:', PROMOTION_STATUSES, filter.status)}
          sx={{ width: '100%' }}
          onChange={(e) => handlerOnChange(e, 'status')}
        />

        <CustomSelect
          {...propsSelect('city', 'Город:', citiesOptions, filter.city)}
          sx={{ width: '100%' }}
          onChange={(e) => handlerOnChange(e, 'city')}
        />
      </Box>

      {promotions?.promotions?.length ? (
        <>
          <Typography color="text.secondary" mb="16px">
            Найдено {getEventDeclensionForm(promotions?.total || 0, 'partners_events')}
          </Typography>

          <EnhancedTable
            rows={promotions?.promotions}
            headCells={COMPANY_PROMOTIONS_HEAD_CELLS}
            filter={filter}
            total={promotions?.total || 0}
            fetching={promotionsLoading}
            heightRow={77}
            setFilter={setFilter}
            showPagination={true}>
            <CompanyPromotionsTableBody
              data={promotions?.promotions}
              onArchive={handleArchivePromotion}
              onApprove={handleApprovePromotion}
              onReject={handleRejectPromotion}
              onActivate={handleActivatePromotion}
              onSendForApproval={handleSendForApproval}
              loading={statusUpdateLoading}
            />
          </EnhancedTable>
        </>
      ) : (
        <NotFoundItems message="Акции не найдены" />
      )}

      <CustomModal
        opened={isArchiveModal}
        modalClose={() => setIsArchiveModal(false)}
        modalSubmit={confirmArchive}
        text={`Вы действительно хотите добавить акцию "${currentPromotion?.translations?.[0]?.promotion_name || 'Без названия'}" в архив?`}
        cancelBtnName="Отмена"
        submitBtnName="Да"
        id="Archive Modal"
      />


      <CustomModal
        opened={errorModal}
        modalClose={closeErrorModal}
        text={errorMessage}
        cancelBtnName="Отмена"
        withoutSubmit
        icon={<ReportRedIcon />}
      />
    </Box>
  );
};
